import { Box, Button, Flex, Grid, Input, rem, Select } from "@mantine/core";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_SortingState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";

import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import {
  IconBarcode,
  IconCalendar,
  IconCoin,
  IconDiscount,
  IconFileExport,
  IconMoneybag,
  IconSearch,
} from "@tabler/icons-react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  repositoryDelivery,
  repositoryPos,
} from "../../../_base/_const/_constVar";
import BreadcrumbLayout1 from "../../../_base/component/_layout/_breadcrumb";
import LoadingOverlayCustom from "../../../common/LoadingOverLayCustom/LoadingOverLayCustom";
import { _localization } from "../../../config/location";
import { DeliveryMoneyReportItem } from "../../../model/DeliveryMoneyReport";
import { MessageResponse } from "../../../model/MessageResponse";
import { SelectListItemModel } from "../../../model/SelectListItem";
import { DatePickerInput } from "@mantine/dates";
import dayjs from "dayjs";
import * as xlsx from "xlsx";
import { toast } from "react-toastify";

// BÁO CÁO TỔNG TIỀN ĐƠN HÀNG

const DeliveryMoneyReport = () => {
  const navigate = useNavigate();
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<DeliveryMoneyReportItem[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    []
  );
  const [globalFilter, setGlobalFilter] = useState("");
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [visible, { toggle, close, open }] = useDisclosure(false);
  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";

  //Mã nhân viên
  const [dataEmployee, setDataEmployee] = useState<SelectListItemModel[]>([]);

  //dataExportExcel
  const [dataExportExcel, setDataExportExcel] = useState<any[]>([]);

  const sizeGrid = { base: 6, sm: 3, md: 3, lg: 3, xl: 1.7 };

  const innitStateSearch = React.useMemo(
    () => ({
      IdNV: _searchJson && checkedPinSearch ? _searchJson?.IdNV : "",
      HasTienMat:
        _searchJson && checkedPinSearch ? _searchJson?.HasTienMat : "",
      HasChuyenKhoan:
        _searchJson && checkedPinSearch ? _searchJson?.HasChuyenKhoan : "",
      HasCaThe: _searchJson && checkedPinSearch ? _searchJson?.HasCaThe : "",
      FromDate:
        _searchJson && checkedPinSearch
          ? _searchJson?.FromDate
          : new Date(
              new Date(
                new Date().setMonth(new Date().getMonth() - 1)
              ).getTime() +
                7 * 60 * 60 * 1000
            )?.toISOString(),
      ToDate:
        _searchJson && checkedPinSearch
          ? _searchJson?.ToDate
          : new Date(new Date().getTime() + 7 * 60 * 60 * 1000)?.toISOString(),
      HasTienMatChuaNop:
        _searchJson && checkedPinSearch ? _searchJson?.HasTienMatChuaNop : "",
    }),
    []
  );

  const formSeachInput = useForm({
    mode: "uncontrolled",
    initialValues: innitStateSearch,
  });

  //Lấy list nhân viên
  const fetchSelectEmployee = async () => {
    const dataApi = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblDmEmployee/get-select"
    );
    if (dataApi && dataApi.success) {
      console.log("dataApi", dataApi);
      const filteredData = dataApi.data
        .filter(
          (item: any) =>
            item.att1 !== null && item.value !== null && item.text !== null
        )
        .map((i: any) => ({
          value: i.value,
          label: ` ${i.att1} - ${i.text}`,
        }));
      setDataEmployee(filteredData);
    }
  };

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);

    try {
      // Tạo URLSearchParams để quản lý các tham số
      const params = new URLSearchParams();

      // Thêm thông tin phân trang
      params.append(
        "Skip",
        (pagination.pageIndex * pagination.pageSize).toString()
      );
      params.append("Take", pagination.pageSize.toString());

      // Lấy giá trị từ form và thêm vào params nếu có giá trị
      const {
        IdNV,
        HasCaThe,
        HasChuyenKhoan,
        HasTienMat,
        FromDate,
        ToDate,
        HasTienMatChuaNop,
      } = formSeachInput.getValues();
      if (IdNV) params.append("IdNV", IdNV);
      if (HasCaThe) params.append("HasCaThe", HasCaThe);
      if (HasChuyenKhoan) params.append("HasChuyenKhoan", HasChuyenKhoan);
      if (HasTienMat) params.append("HasTienMat", HasTienMat);
      if (FromDate) params.append("FromDate", FromDate);
      if (ToDate) params.append("ToDate", ToDate);
      if (HasTienMatChuaNop)
        params.append("HasTienMatChuaNop", HasTienMatChuaNop);

      const url = `/api/v1/TblDelivery/get-list-amount-total-all-report?${params.toString()}`;

      const response = await repositoryDelivery.get<MessageResponse<any>>(
        `${url}`
      );
      if (response && response.success) {
        const result = response.data;
        setData(result);
        setRowCount(response.totalCount);
        // Gọi API lần thứ hai nếu cần lấy toàn bộ dữ liệu
        if (response.totalCount > pagination.pageSize) {
          const allParams = new URLSearchParams(params);
          allParams.set("Skip", "0"); // Đặt Skip = 0
          allParams.set("Take", response.totalCount.toString()); // Cập nhật Take = totalCount
          const allUrl = `/api/v1/TblDelivery/get-list-amount-total-all-report?${allParams.toString()}`;
          const allResponse = await repositoryDelivery.get<
            MessageResponse<any>
          >(`${allUrl}`);
          console.log("allResponse", allResponse);
          if (allResponse && allResponse.success) {
            setDataExportExcel(allResponse.data); // Ghi đè dữ liệu với toàn bộ kết quả
          }
        } else {
          setDataExportExcel(result); // Ghi đè dữ liệu với toàn bộ kết quả
        }
      } else {
        setData([]);
        setRowCount(0);
        setIsLoading(false);
      }
    } catch (error) {
      setData([]);
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify(formSeachInput.getValues())
      );
    }
  };

  const columns = React.useMemo<MRT_ColumnDef<DeliveryMoneyReportItem>[]>(
    () => [
      {
        accessorKey: "idNvgh",
        header: "ID nhân viên giao hàng",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
        size: 300,
      },
      {
        accessorKey: "maNVGH",
        header: "Mã nhân viên giao hàng",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
        size: 300,
      },
      {
        accessorKey: "tenNVGH",
        header: "Tên nhân viên giao hàng",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
        size: 300,
      },
      {
        accessorKey: "tienMat",
        header: "Tiền mặt",
        Cell: ({ renderedCellValue }) => (
          <>{formatCurrencyVND(renderedCellValue)}</>
        ),
        size: 300,
      },
      {
        accessorKey: "chuyenKhoan",
        header: "Tiền chuyển khoản",
        Cell: ({ renderedCellValue }) => (
          <>{formatCurrencyVND(renderedCellValue)}</>
        ),
        size: 300,
      },
      {
        accessorKey: "caThe",
        header: "Tiền cà thẻ",
        Cell: ({ renderedCellValue }) => (
          <>{formatCurrencyVND(renderedCellValue)}</>
        ),
        size: 300,
      },
      {
        accessorKey: "tienMatChuaNop",
        header: "Tiền mặt chưa nộp",
        Cell: ({ renderedCellValue }) => (
          <>{formatCurrencyVND(renderedCellValue)}</>
        ),
        size: 300,
      },
    ],
    []
  );

  const table = useMantineReactTable({
    columns,
    data: data || [],
    enableColumnResizing: true,
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,

    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["SoHd"],
        // right: ["tTienDh", "action"],
      },
      columnVisibility: { id: true },
      density: "xs",
    },
    enableRowSelection: false,
    mantineTableContainerProps: {
      style: { maxHeight: height - 100, minHeight: height - 100 },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    onGlobalFilterChange: setGlobalFilter,
    onColumnFiltersChange: setColumnFilters,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "550",
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      sorting,
      rowSelection,
    },
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
  });

  const handleExport = () => {
    try {
      // Tạo ánh xạ tiêu đề từ columns
      const columnHeaders = columns.reduce((acc, column) => {
        if (column.accessorKey && column.header) {
          acc[column.accessorKey] = column.header; // Tạo ánh xạ giữa accessorKey và header
        }
        return acc;
      }, {} as Record<string, string>);

      // Lấy thứ tự cột từ columns
      const columnOrder = columns
        .filter((column) => column.accessorKey) // Chỉ lấy các cột có accessorKey
        .map((column) => column.accessorKey as string);

      // Chuyển đổi dữ liệu với tiêu đề cột mới và sắp xếp theo thứ tự cột
      const transformDataForExport = (data: any[]) => {
        return data.map((row) => {
          const transformedRow: any = {};
          columnOrder.forEach((key) => {
            if (columnHeaders[key]) {
              transformedRow[columnHeaders[key]] = row[key]; // Đổi tên cột theo header
            }
          });
          return transformedRow;
        });
      };

      const transformedData = transformDataForExport(dataExportExcel);
      console.log("transformedData", transformedData);
      // Tạo worksheet và workbook
      const worksheet = xlsx.utils.json_to_sheet(transformedData);
      const workbook = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(workbook, worksheet, "Data");

      // Ghi file Excel
      xlsx.writeFile(workbook, "Bao_cao_tong_tien_don_hang.xlsx");
      toast.success("Export excel thành công", { autoClose: 1500 });
    } catch (error) {
      console.error("Error exporting Excel:", error);
      toast.error("Export excel thất bại", { autoClose: 1500 });
    }
  };

  useEffect(() => {
    fetchSelectEmployee();
  }, []);
  useEffect(() => {
    fetchData();
  }, [pagination]);

  const formatCurrencyVND = (value: any) => {
    if (value == null) {
      return "";
    }
    // Định dạng số theo chuẩn Việt Nam
    return value.toLocaleString("vi-VN", {
      minimumFractionDigits: 0, // Không hiển thị phần thập phân
      maximumFractionDigits: 0, // Đảm bảo không có chữ số sau dấu phẩy
    });
  };

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 190 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (150 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  return (
    <Box pos="relative">
      <LoadingOverlayCustom visible={visible} />
      <Flex
        justify="space-between"
        align="center"
        style={{
          border: "1px solid #dee2e6",
          padding: "5px 10px",
        }}
      >
        <BreadcrumbLayout1></BreadcrumbLayout1>
        <Button
          leftSection={
            <IconFileExport style={{ width: rem(14), height: rem(14) }} />
          }
          onClick={() => handleExport()}
        >
          Export Excel
        </Button>
      </Flex>
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          flexWrap: "wrap",
          // marginTop: "10px",
        }}
      >
        <Grid style={{ width: "100%" }} mt={10}>
          <Grid.Col span={sizeGrid}>
            <Select
              size="sm"
              placeholder="Mã nhân viên"
              clearable
              searchable
              data={dataEmployee}
              value={
                formSeachInput.getValues()?.IdNV &&
                formSeachInput.getValues()?.IdNV?.length > 0
                  ? formSeachInput.getValues().IdNV
                  : ""
              }
              leftSection={<IconBarcode size={20} color="#15aabf" />}
              onChange={(e) => {
                formSeachInput.setFieldValue("IdNV", e ? e.toString() : "");
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              size="sm"
              placeholder="Tiền mặt"
              clearable
              leftSection={<IconCoin size={20} color="#15aabf" />}
              data={[
                { value: "true", label: "Đơn có tiền mặt" },
                {
                  value: "false",
                  label: "Đơn không có tiền mặt",
                },
              ]}
              value={
                formSeachInput.getValues()?.HasTienMat &&
                formSeachInput.getValues()?.HasTienMat?.length > 0
                  ? formSeachInput.getValues().HasTienMat
                  : ""
              }
              onChange={(e) => {
                formSeachInput.setFieldValue(
                  "HasTienMat",
                  e ? e.toString() : ""
                );
              }}
            />
          </Grid.Col>

          <Grid.Col span={sizeGrid}>
            <Select
              size="sm"
              placeholder="Tiền mặt chưa nộp"
              clearable
              leftSection={<IconCoin size={20} color="#15aabf" />}
              data={[
                { value: "true", label: "Đơn có tiền mặt chưa nộp" },
                {
                  value: "false",
                  label: "Đơn không có tiền mặt chưa nộp",
                },
              ]}
              value={
                formSeachInput.getValues()?.HasTienMatChuaNop &&
                formSeachInput.getValues()?.HasTienMatChuaNop?.length > 0
                  ? formSeachInput.getValues().HasTienMatChuaNop
                  : ""
              }
              onChange={(e) => {
                formSeachInput.setFieldValue(
                  "HasTienMatChuaNop",
                  e ? e.toString() : ""
                );
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              size="sm"
              placeholder="Chuyển khoản"
              clearable
              leftSection={<IconDiscount size={20} color="#15aabf" />}
              data={[
                { value: "true", label: "Đơn có chuyển khoản" },
                {
                  value: "false",
                  label: "Đơn không có chuyển khoản",
                },
              ]}
              value={
                formSeachInput.getValues()?.HasChuyenKhoan &&
                formSeachInput.getValues()?.HasChuyenKhoan?.length > 0
                  ? formSeachInput.getValues().HasChuyenKhoan
                  : ""
              }
              onChange={(e) => {
                formSeachInput.setFieldValue(
                  "HasChuyenKhoan",
                  e ? e.toString() : ""
                );
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              size="sm"
              placeholder="Cà thẻ"
              clearable
              leftSection={<IconMoneybag size={20} color="#15aabf" />}
              data={[
                { value: "true", label: "Đơn có cà thẻ" },
                {
                  value: "false",
                  label: "Đơn không có cà thẻ",
                },
              ]}
              value={
                formSeachInput.getValues()?.HasCaThe &&
                formSeachInput.getValues()?.HasCaThe?.length > 0
                  ? formSeachInput.getValues().HasCaThe
                  : ""
              }
              onChange={(e) => {
                formSeachInput.setFieldValue("HasCaThe", e ? e.toString() : "");
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              size="sm"
              placeholder="Từ ngày"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              leftSection={<IconCalendar color="#15aabf" />}
              key={formSeachInput.key("FromDate")}
              {...formSeachInput.getInputProps("FromDate")}
              value={
                formSeachInput.getValues().FromDate
                  ? dayjs(formSeachInput.getValues().FromDate).toDate()
                  : null // Nếu không có giá trị, đặt null
              }
              onChange={(date) =>
                formSeachInput.setFieldValue(
                  "FromDate",
                  date ? dayjs(date).format("YYYY-MM-DDTHH:mm:ss") : ""
                )
              }
              clearable
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              size="sm"
              placeholder="Đến ngày"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              leftSection={<IconCalendar color="#15aabf" />}
              clearable
              key={formSeachInput.key("ToDate")}
              {...formSeachInput.getInputProps("ToDate")}
              value={
                formSeachInput.getValues().ToDate
                  ? dayjs(formSeachInput.getValues().ToDate).toDate()
                  : null // Nếu không có giá trị, đặt null
              }
              onChange={(date) =>
                formSeachInput.setFieldValue(
                  "ToDate",
                  date ? dayjs(date).format("YYYY-MM-DDTHH:mm:ss") : ""
                )
              }
            />
          </Grid.Col>

          <Grid.Col span={sizeGrid}>
            <Button
              type="submit"
              leftSection={<IconSearch size={20} />}
              color="blue"
              variant="outline"
              onClick={async () => {
                await fetchData();
              }}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </Box>

      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </Box>
  );
};

export default DeliveryMoneyReport;
